import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useReveal } from "@/hooks/useReveal";

const Stat = ({ value, label, idx }) => (
  <div className="flex flex-col gap-2 py-6 border-t border-white/10">
    <span className="text-xs tracking-[0.24em] text-zinc-500">
      <span className="ps-number text-[var(--ps-gold)] mr-2">
        0{idx}
      </span>
    </span>
    <span className="font-serif-display text-5xl md:text-6xl text-white">{value}</span>
    <span className="text-sm text-zinc-400">{label}</span>
  </div>
);

const About = () => {
  const { t } = useLanguage();
  const { ref, visible } = useReveal();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-40"
    >
      <div
        ref={ref}
        className={`max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 reveal ${
          visible ? "is-visible" : ""
        }`}
      >
        <div className="md:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-6 h-[1px] bg-[var(--ps-gold)]" />
            <span className="text-xs tracking-[0.3em] text-[var(--ps-gold)]">
              {t.about.kicker}
            </span>
          </div>
          <h2
            data-testid="about-title"
            className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-white"
          >
            {t.about.title.split(" ").slice(0, 3).join(" ")}{" "}
            <span className="italic text-[var(--ps-gold)]">
              {t.about.title.split(" ").slice(3).join(" ")}
            </span>
          </h2>
        </div>

        <div className="md:col-span-7 md:col-start-6">
          <p className="text-lg md:text-xl text-zinc-200 leading-relaxed font-serif-display">
            {t.about.body1}
          </p>
          <p className="mt-6 text-base text-zinc-400 leading-relaxed max-w-2xl">
            {t.about.body2}
          </p>

          <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-8">
            <Stat idx={1} value={t.about.stat1_value} label={t.about.stat1_label} />
            <Stat idx={2} value={t.about.stat2_value} label={t.about.stat2_label} />
            <Stat idx={3} value={t.about.stat3_value} label={t.about.stat3_label} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
